import React, { Component } from 'react';
import { Collapse } from 'react-collapse';
import { NavLink } from 'react-router-dom';

const Leftover = (props) => {
  let redStyle = {
    'borderColor': 'red',
    'maxWidth': '90px'
  }
  let yellowStyle = {
    'borderColor': '#fabb3d',
    'maxWidth': '90px'
  }
  let normalStyle = {
    'borderColor': 'rgb(233, 235, 236)',
    'maxWidth': '90px'
  }
  return(
    <tr>
      <td className="hidden-xxs-down">
        <NavLink to={`/inventory/${props.leftover.inventory_id}/`}>
          {props.leftover.inventory_id}
        </NavLink>
      </td>
      <td>
        {props.leftover.name}
      </td>
      <td>
        <div className="form-check-label">
          <input className="form-check-input" type="checkbox" value={props.leftover.id} checked={props.leftover.has_leftover} onChange={props.toggleCheckBox}/>
        </div>
      </td>
      <td>
        <div className="d-flex justify-content-start align-items-center">
          <div>
            <input type="number" className="form-control" value={props.leftover.amount}
              disabled={!props.leftover.has_leftover}
              onChange={(event)=>props.onLeftoverAmountChange(event,props.index)}
              style={(props.leftoverError.indexOf(props.index) !== -1)? redStyle
                  : (props.leftoverWarning.indexOf(props.index) !== -1)? yellowStyle: normalStyle}
              onBlur={()=>props.onAmountBlur(props.index)}/>
          </div>
          <div className="ml-1">
            <span className="badge badge-pill badge-info">{props.leftover.item.measure_unit ? props.leftover.item.measure_unit : 'lb'}</span>
          </div>
        </div>
      </td>
    </tr>
  )
}

export default class ListLeftovers extends Component {

  constructor(props) {
    super(props);
    this.state = { isOpened: true }
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  toggleCollapse(){
    this.setState({isOpened: !this.state.isOpened});
  }

  render(){
    return(
      <div className="card">
        <div className="d-flex justify-content-between align-items-center card-header pointer" onClick={this.toggleCollapse}>
          <div className="d-flex">
            <h5 className="mr-05 mb-0">{this.props.title}</h5>
            {this.state.isOpened ? null : <span>{' (' + this.props.leftovers.length + ')'} </span> }
          </div>
          <i className={`fa ${this.state.isOpened ? "fa-caret-up" : "fa-caret-down"}`}></i>
        </div>
        <Collapse isOpened={this.state.isOpened}>
          <div className="card-block p-0 m-0">
            {this.props.leftovers.length ?
              <table className="table table-striped table-hover mb-0">
                <thead>
                  <tr>
                    <th className="hidden-xs-down">Inventory ID</th><th className="hidden-sm-up hidden-xxs-down">ID</th>
                    <th>Item</th>
                    <th className="hidden-xs-down">Has leftovers?</th><th className="hidden-sm-up">Has?</th>
                    <th className="hidden-xs-down">Qty Left</th><th className="hidden-sm-up">Left</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.leftovers.map((leftover,index)=>{
                    return(
                      <Leftover
                        leftover={leftover}
                        toggleCheckBox={this.props.toggleCheckBox}
                        onLeftoverAmountChange={this.props.onLeftoverAmountChange}
                        leftoverError={this.props.leftoverError}
                        leftoverWarning={this.props.leftoverWarning}
                        onAmountBlur={this.props.onAmountBlur}
                        index={index}
                        key={index}
                      />
                    )
                  })}
                </tbody>
              </table>
            :
              <div className="empty-table"><span>No leftovers yet</span></div>
            }
          </div>
        </Collapse>
      </div>
    )
  }
}
